export default "location\tlocationId\tname\tlogo\tcite\tpicto\tmetier\tdescription\trdv\ttel\tfiche\n";